const quantityLimit = 100;

export const initialState = {
  items: [],
};
export const reducer = (state, action) => {
  switch (action.type) {
    case "addToCart":
      const updatedItems = state.items.map((item) => {
        return item.id === action.id
          ? {
            ...item,
            quantity: item?.quantity
              ? item.quantity === quantityLimit
                ? item.quantity
                : item.quantity + 1
              : 1,
          }
          : item;
      });
      return { ...state, items: updatedItems };
    case "decrement":
      return {
        ...state,
        items: state.items.map((item) => {
          return item.id === action.id
            ? {
              ...item,
              quantity:
                item?.quantity > 0 ?
                  item.quantity === 1 ? undefined
                    : item.quantity - 1 : item?.quantity
            }
            : item;
        }),
      };
    case "setItems":
      return {
        ...state,
        items: action.items,
      };
    case "reset":
      return initialState;
    default:
      return state;
  }
};
